import React from 'react';
import WeatherDetails from './components/WeatherDetails';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Weather App</h1>
      <WeatherDetails />
    </div>
  );
}

export default App;
